import {isEmpty} from "lodash";

export const getFundLimit = ({ selectedFund, userRegistrationTypeInfo }) => {
  const {
    selectedRegistrationType: { currentYearLimit },
  } = userRegistrationTypeInfo;

  if (isEmpty(currentYearLimit)) {
    return 0;
  }

  const limit = currentYearLimit.filter((obj) => obj.type === 'EXCHANGE');
  if (isEmpty(limit)) {
    return 0;
  }
  return limit[0].minimum || selectedFund.minimumInvestmentAmount;
}